import React, { useEffect } from 'react';
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";

import './LoginPage.scss' ;
import LoginForm from "root/LoginForm";

import { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const LoginPage = ( props ) =>
{
    const { getCustomObject, action, reason, username, token } = useGlobalContext ();

    useEffect ( () =>
    {
        document.body.classList.add ( 'bg-login' );

        return () =>
        {
            document.body.classList.remove ( 'bg-login' );
        };
    } );

    const logoPath = getCustomObject ( ConfigOptions.LOGIN_PAGE_LOGO_PATH );

    return (
        <ErrorBoundary FallbackComponent={ FallbackComponent }>
            <div className='login-container'>
                <LoginForm useProvider={ false } mode={ action } reason={ reason } username={ username }
                           token={ token } defaultLogo={ logoPath }/>
            </div>
        </ErrorBoundary>
    )
}

export default LoginPage;
